export const V3_SIGNUP_PAGE = 'onboarding/V3_SIGNUP_PAGE'
export const V3_EMAIL_PAGE = 'onboarding/V3_EMAIL_PAGE'
export const V3_COMPANY_PAGE = 'onboarding/V3_COMPANY_PAGE'
export const V3_VERIFICATION_PAGE = 'onboarding/V3_VERIFICATION_PAGE'
